import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: var(--spacing-stack-md); /* 32px */
  padding: var(--spacing-stack-md) var(--spacing-stack-xs); /* 30px 16px */
  overflow: hidden;
`;
